<template>
  <div class="login-agreement-con">
    <div class="login-agreement">
      <div class="login-agreement-title">
        <span>戴尔共创Precision 2047号设计大赛</span>
        <span>网站用户服务协议</span>
      </div>
      <div class="login-agreement-con">
        <p class="button36">戴尔共创Precision 2047号设计大赛网站用户服务协议 戴尔共创Precision 2047号设计大赛网站用户服务（以下简称“本服务”）
          是由戴尔（中国）有限公司及其关联公司、分公司、 子公司（以下简称“本公司”或“戴尔”） 向广大网络用户提供的专享服务。本《戴尔
          共创Precision 2047号设计大赛网站用户服务协议》 （以下简称“本服务协议”）是您与戴尔之间就注册戴尔共创Precision 2047号
          设计大赛网站用户账号及使用戴尔的各项服务等相关事宜所订立的协议。</p>

        <p class="bold">为使用戴尔的服务，请您仔细阅读并遵守本服务协议下的全部内容，特别是涉及免除或者设置责任限制的条款，该类条款将以黑体加粗或加下
          划线的形式提示您重点注意。 </p>
        <p class="button36">本服务协议由您和本公司签订。</p>

        <p class="bold"> 一、声明与承诺</p>
        <p>1. 您确认，在您注册成为戴尔共创Precision 2047号设计大赛网站用户之前，已充分阅读、理解并接受本协议的全部内容，一旦您使用本
          服务，即表示您同意遵守与本协议之所有约定。</p>
        <p><span class="bold">如您勾选或点击同意本协议</span>并通过注册程序或其他任何方式使用或接受戴尔的任何服务，即视为您已阅读并同意本服务协议，自愿接受本服务协
          议的所有内容。请您在决定注册或使用服务前再次确认您已知悉并完全理解本服务协议的所有内容</p>
        <p>2. 除非您已阅读并接受本服务协议所有条款，否则您将不能注册戴尔共创Precision 2047号设计大赛网站用户账号或使用戴尔的服务。如您
          不同意本服务协议的任意内容，请勿注册或使用戴尔的服务，并应立即停止注册程序。如您对本服务协议的内容（特别是涉及免除或者责任限制的
          条款）有任何疑义，可随时按照本服务协议中列明的联系方式与我们联系，我们将根据您的要求为您进一步解释和说明相关内容。用户直接或通过
          各类方式（如站外引用等）间接使用戴尔共创Precision 2047号设计大赛网站服务和数据的行为，都将被视作已无条件接受本协议所涉全部内容；
          若用户对本协议的任何条款有异议，请停止使用戴尔共创Precision 2047号设计大赛网站所提供的全部服务。</p>
        <p>3. 您同意，本公司有权随时对本协议内容进行单方面的变更，并以在本公司网站、小程序、公众号等官方平台公告的方式予以公布；若您在本协议
          内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容使用本服务；若您不同意修改后的
          协议内容，您应立即停止使用本服务。</p>
        <p class="button36">4. 您声明，在您同意接受本协议并成为戴尔共创Precision 2047号设计大赛网站用户时，您是具有法律规定的完全民事权利能力和民事行为能力，
          能够独立承担民事责任的自然人、法人或其他组织。</p>

        <p class="bold">二、协议的主体与范围</p>
        <p class="bold">1. 签约主体</p>
        <p>视您所使用的具体服务而定，“戴尔”是戴尔（中国）有限公司及其关联公司、分公司、子公司是与您签约本协议的主体的统称，您可在相关服务的具体条款
          或说明文件中查看上述主体的名称和信息。</p>
        <p>“用户“是指使用戴尔相关服务的使用人，在本服务协议中更多称呼为“您”。</p>
        <p class="bold">2. 协议内容</p>
        <p>本服务协议内容同时包括：</p>
        <p>2.1 本《戴尔共创Precision 2047号设计大赛网站用户服务协议》文本</p>
        <p class="button36">2.2 戴尔共创Precision 2047号设计大赛中出现的活动规则、活动安排等一切本活动涉及的规则和制度。</p>

        <p class="bold">三、用户注册</p>
        <p>1. 您自愿注册为戴尔共创Precision 2047号设计大赛网站用户。</p>
        <p>2. 在您注册为戴尔共创Precision 2047号设计大赛网站用户时，我们会要求绑定手机号码来识别您的身份。该账号因任何原因受到潜
          在或现实风险时，您应该立即和本公司取得联系。</p>
        <p>3. 您注册为戴尔共创Precision 2047号设计大赛网站用户后，可以享有用户权益，在您使用本服务的同时，您也自愿同意及遵守本活
          动的相关规定。</p>
        <p class="button36">4. 您可自行编辑注册信息中的账号名称、信息等，但<span class="bold">应遵守中华人民共和国相关法律法规、您所在国家或地区之法令及相关国际惯例</span>
          ，不得含有违法和违反道德信息。</p>

        <p  class="bold">四、戴尔共创Precision 2047号设计大赛网站用户概要</p>
        <p>1. 戴尔共创Precision 2047号设计大赛网站用户：凭注册账号，您拥有唯一编号，并绑定一个您正常使用的移动手机号码。</p>
        <p class="bold">2. 服务异常处理：您使用本服务时，可能由于不可抗拒因素，造成本服务无法提供。您须确保您所输入的资料无误，如果因输入资料错误造成本公司无法及时与您联系的，本公司不承担任何损害赔偿责任。</p>
        <p class="bold">3. 您同意，基于运营和安全的需要，本公司可以暂时停止提供或者限制戴尔共创Precision 2047号设计大赛网站的部分功能或服务，
          或提供新的功能或服务，在任何功能减少、增加或者变化时，如您仍然使用本服务，表示您仍然同意本协议。</p>
        <p class="button36 bold">4. 您同意，在戴尔提供服务过程中戴尔可以以各种方式投放商业性广告或其他任何类型的商业信息（包括但不限于在戴尔网站的任何页面上投放广告），并且，
          您同意接受戴尔通过电子邮件或其他方式向用户发送商品促销或其他相关商业信息。</p>

        <p class="bold">五、戴尔共创Precision 2047号设计大赛网站用户办理</p>
        <p class="bold">（一）用户相关</p>
        <p class="bold">1.若有合理理由怀疑您提供的资料错误、不实、过时或不完整的，戴尔有权暂停或终止向您提供部分或全部的用户服务。戴尔对此不承担任何责任，您将承担因此产生的任何直接或间接支出。</p>
        <p>2. 因您未及时更新资料，导致本服务无法提供或提供时发生任何错误，您将承担因此产生的一切后果，戴尔不承担任何责任。</p>
        <p><span class="bold">3. 您应对您的戴尔共创Precision 2047号设计大赛网站用户账号负责，只有您本人可以使用您的戴尔共创Precision 2047号设计大赛网站用户账号，该账号不可转让、不可赠与、不可继承。</span>
          您同意，若您丧失全部或部分民事权利能力或民事行为能力，本公司有权根据有效法律文书（包括但不限于生效的法院判决、生效的遗嘱等）处置您的戴尔共创Precision 2047号设计大赛网站用户账号。</p>
        <p class="button36">4. 戴尔共创Precision 2047号设计大赛网站及其关联方未阅览或监视链接到戴尔以外的任何网站，因此对任何该等链接网站的内容不承担责任。您访问该等网站须自行承担风险。</p>

        <p class="bold">（二）账号安全</p>
        <p>您将对使用该用户账号进行的一切操作及言论负完全的责任，您同意：</p>
        <p>1. 妥善保管账号信息，不向其他任何人泄露该账号信息，亦不使用其他任何人的名义使用账户。</p>
        <p class="button36"><span class="bold">2. 如您发现有他人冒用或盗用您的账号或任何其他未经合法授权之情形时，应立即以有效方式通知本公司，要求本公司暂停相关服务</span>。同时，您理解本公司对您的请求采取行动需要合理期限，在此之前，本公司
          对已执行的指令及（或）所导致的您的损失不承担任何责任。</p>

        <p class="bold">六、戴尔共创Precision 2047号设计大赛网站用户服务使用限制</p>
        <p class="bold">（一）您在使用戴尔共创Precision 2047号设计大赛网站用户相关服务时，应遵守中华人民共和国相关法律法规、您所在国家或地区之法令及相关国际惯例，不将本服务用于任何非法目的（包括用于禁止或限制交易物品的交易），
          也不以任何非法方式使用本服务。</p>
        <p><span class="bold">（二）您不得利用戴尔共创Precision 2047号设计大赛网站用户相关服务从事侵害他人合法权益之行为，否则应承担所有相关法律责任，因此导致本公司或本公司雇员受损的，您应承担赔偿责任</span>。下述行为包括但不限于：</p>
        <p>1. 侵害他人名誉权、隐私权、商业秘密、商标权、著作权、专利权等合法权益。</p>
        <p>2. 违反依法定或约定之保密义务。</p>
        <p>3. 冒用他人名义使用本服务。</p>
        <p>4. 从事任何可能含有电脑病毒或是可能侵害本服务系统、资料之行为。</p>
        <p class="button36">5. 其他本公司有正当理由认为不适当之行为。</p>

        <p class="button36"><span class="bold">（三）您在戴尔共创Precision 2047号设计大赛网站发表的内容仅表明您个人的立场和观点，并不代表戴尔的立场或观点</span>。您须自行对所发表内容负责，因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律及连带责任。戴尔不承担任何法律及连带责任。</p>

        <p class="bold">（四）您理解并同意，本公司不对因下述任一情况导致的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其他无形损失的损害赔偿（无论本公司是否已被告知该等损害赔偿的可能性）：</p>
        <p>1. 本公司有权基于单方判断，包含但不限于本公司认为您已经违反本协议的明文规定及原则，法律法规，国家政策及公序良俗等，暂停、中断或终止向您提供本服务或其任何部分，并移除您的资料。</p>
        <p>2. 本公司在发现异常交易或有疑义或有违法之嫌时，有权不经通知先行暂停或终止该账号的使用，并拒绝您使用本服务之部分或全部功能。</p>
        <p class="button36">3. 在必要时，本公司无需事先通知即可终止提供本服务，并暂停、关闭或删除该账号及您账号中所有相关资料及档案。</p>

        <p class="bold">七、隐私权保护</p>
        <p>一旦您同意本协议或使用本服务，您即同意本公司按照以下条款来使用和披露您的个人信息。</p>
        <p>1. 在您注册为戴尔共创Precision 2047号设计大赛网站用户时，我们会要求您绑定本人手机号码来识别您的身份。<span class="bold">该账号因任何原因受到潜在或现实风险时，您应该立即和本公司取得联系</span>。</p>
        <p class="bold">您注册该账号时应向本公司提供您的真实移动手机号码，您还需填写相关附加信息（包括但不限于您的姓名、邮箱、通讯地址等个人资料）。为有针对性地向您提供新的服务和活动，您了解并同意本公司将通过您的手机或其他渠道通知您这些信息。您承认所填写的内容均为事实，并授权戴尔向您本人或有关机构进行核对。</p>
        <p>2 广告</p>
        <p class="bold">本公司会对用户的身份数据进行综合统计，并出于销售、奖励和活动目的等商业需要合法使用。</p>
        <p>3. 第三方</p>
        <p>除非获得您本人的书面同意，本公司不会向任何无关第三方提供、出售、出租、分享您的个人信息。除了按法定或约定情况下披露您的信息。</p>
        <p class="bold">您同意由戴尔以及其下属的门店、附属公司、关联公司、分公司、子公司及与之拥有权益的任何公司（统称“上述公司”），以推广上述公司的商品/服务之需要（包括行政研究、市场研究、宣传推广等经营需要）及其他合法目的使用您个人信息（包括通过邮寄、短信、电邮等方式向本人传达商品/服务资讯等)。</p>
        <p>4 安全</p>
        <p>本公司以现有技术提供严格的安全措施来使本公司掌握的信息不丢失、不被滥用和变造。这些安全措施包括向其他服务器备份数据和对用户密码加密。尽管有这些安全措施，但本公司无法保证这些信息的绝对安全。</p>
        <p class="button36">其他隐私政策，参见《戴尔共创Precision 2047号设计大赛网站用户隐私协议》。</p>

        <p class="bold">八、系统中断或故障</p>
        <p>系统因下列状况无法正常运作，使您无法使用各项服务时，本公司不承担损害赔偿责任，该状况包括但不限于：</p>
        <p>1. 本公司通过官方渠道公告之系统停机维护期间。</p>
        <p>2. 电信设备出现故障不能进行数据传输的。</p>
        <p>3. 因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成本公司系统障碍不能执行业务的。</p>
        <p class="button36">4. 由于黑客攻击、电信部门技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。</p>

        <p class="bold">九、跨主体共享数据说明</p>
        <p>您为使用我方平台服务时，向我们提供的相关数据信息，可能涉及如下场景：</p>
        <p>1. 客服及争议处理：在为您提供客服或争议纠纷处理服务时，我们需要收集和处理您的必要信息，用于验证您的身份，向您回复及回访我们服务人员的服务质量。</p>
        <p class="bold">2. 安全保障：为保障您的账号安全，我们需要收集和处理您的设备信息、日志信息，我们也会将这些信息用于预防发生各类违法违规或其他主体合法权益被侵害的情况。</p>
        <p class="bold">其他附加功能：为提升您的体验，我们还为您提供了很多附加功能。例如使用您所在位置向您提供附近的门店/机器人商店，您可按需选择使用或关闭。</p>
        <p class="bold">为便于我们基于平台账号向您提供产品和服务，您的个人信息可能会与我们的关联公司或第三方平台（具体包括：微信、企业微信、天猫、支付宝、抖音、京东，您的信息在第三方平台收
          集后，以明文或部分加密的方式传输给我方）共享，我们可能就共享的信息进行必要的收集、存储、使用、加工、传输、提供、公开或删除等操作，我们只会共享必要的个人信息。未经您的
          特别同意，我们不会收集您的敏感信息：如生物识别、宗教信仰、特定身份、医疗健康、金融账号、行踪轨迹等信息。</p>
        <p>本协议内所述“关联公司“是指跟我方存在如下关系的公司：</p>
        <p>1. 在股权、资金、经营、购销等方面存在直接或者间接的控制关系；</p>
        <p>2. 直接或者间接地同为第三者控制；</p>
        <p class="button36">3. 在利益上具有相关联的其他关系。</p>

        <p class="bold">十、责任范围及责任限制</p>
        <p class="bold">1. 本公司仅对本协议中列明的责任范围承担负责。</p>
        <p class="bold">2. 戴尔共创Precision 2047号设计大赛网站用户帐户信息是由用户本人自行提供的，本公司无法保证该信息之准确、及时和完整，您应对您的判断及选择承担全部责任。</p>
        <p class="bold">3. 本服务之合作单位，所提供之服务品质及内容由该合作单位自行负责。</p>
        <p class="bold">4. 您经由本服务之使用下载或取得任何资料，应由您自行考量且自负风险，因资料之下载而导致您电脑系统之任何损坏或资料流失，您应负完全责任。</p>
        <p class="bold">5. 您自本公司及本公司工作人员或经由本服务取得之建议和信息，无论其为书面或口头形式，均不构成本公司对您之保证，请您谨慎斟酌。</p>
        <p class="bold">6. 在法律允许的情况下，本公司对于与本协议有关或由本协议引起的对您造成的任何间接的、惩罚性的、特殊的、派生的损失，不论是如何产生的，也不论是由对本协议的违约（包括
          违反保证）还是由侵权造成的，均不负有任何责任，即使事先已被告知此等损失的可能性。另外即使本协议规定的排他性救济没有达到其基本目的，也应排除本公司对上述损失的责任。</p>
        <p class="bold">7. 您知悉并承诺，在使用戴尔所提供的服务的过程中，您应遵守相关法律法规和公众道德，不应从事如下违反法律法规的规定，影响正常服务提供或损害他人合法利益的行为：</p>
        <p class="bold">7.1 不应利用戴尔平台或相关服务危害国家安全、破坏政治稳定、泄露国家秘密，不侵犯国家、社会、集体利益和第三方的合法权益，不从事违法犯罪活动，不设立用于实施诈骗，传授犯罪
          方法，制作或者销售违禁物品、管制物品等违法犯罪活动的网站、通讯群组，不利用网络发布涉及实施诈骗，制作或者销售违禁物品、管制物品以及其他违法犯罪活动的信息。</p>
        <p class="bold">7.2 不应制作、发布、复制、查阅和传播、存储、链接下列信息：反对宪法所确定的基本原则的；危害国家安全，泄露国家秘密，颠覆国家政权，推翻社会主义制度，煽动分裂国家，破坏国家
          统一的；损害国家荣誉和利益的；煽动民族仇恨、民族歧视，破坏民族团结的；破坏国家宗教政策，宣扬邪教和封建迷信的；煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；捏造、散布
          谣言，侵犯他人权利，扰乱经济、社会秩序，破坏社会稳定的；散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；悔辱或者诽谤他人，侵害他人合法权益的；宣扬恐怖主义、极端主义
          的；违背当地风俗习惯的；含有法律、行政法规禁止的其他内容的。</p>
        <p class="bold">7.3 不应从事下列危害计算机信息网络安全的活动：对网络服务及相关软硬件设施进行破解、破坏、删除、修改或者增加的；对计算机信息网络中存储或者传输的数据和应用程序进行删除、修改
          或者增加的；使用软件或硬件等方式窃取他人口令、非法入侵他人计算机系统；故意制作、传播计算机病毒等破坏性程序的；其他危害计算机信息网络安全的活动。</p>
        <p class="bold">7.4 不应擅自复制和使用网络上未公开和未授权的文件。除相关著作权人明示同意，不应在网络中擅自破解、传播、下载或复制第三人享有著作权的软件或进行其他任何侵害他人知识产权的活动。</p>
        <p class="bold">7.5 不应因对戴尔相关服务的使用行为导致戴尔卷入政治和社会公共事件。</p>
        <p class="bold">7.6 不应通过侵犯第三人合法权益、作弊、扰乱系统、实施网络攻击、恶意套现、刷信誉、批量注册、用机器注册戴尔平台账号、用机器模拟客户端等手段进行交易或参加戴尔或其所授权的第三方发布的任何活动。</p>
        <p class="button36 bold">7.7 未经戴尔事先书面许可，不应自行或授权、协助任何第三方非法抓取戴尔所展示的任何内容（“非法抓取”是指采用未经戴尔认可的程序或者非正常浏览等技术手段获取内容数据的行为）。
          如您在使用戴尔服务过程中涉及上述行为中的一项或多项，则需要对自己的行为独立承担法律责任。
        </p>

        <p class="bold">十一、商标、知识产权的保护</p>
        <p class="bold">1. 戴尔共创Precision 2047号设计大赛网站原有的所有内容，包括但不限于著作、图片、档案、资讯、资料、网站架构、网站画面的安排、网页设计，均由本公司或本公司关联企业依法拥有其知识产权，包括但不限于
          商标权、专利权、著作权、商业秘密等。</p>
        <p class="bold">2. 非经本公司或本公司关联企业书面同意，任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表本网站程序和网页内容（包括图片、文字和视频）。</p>
        <p class="button36 bold">3. 尊重知识产权是您应尽的义务，如有违反，您应独立承担法律责任。</p>

        <p class="bold">十二、不可抗力或其他免责事由</p>
        <p class="bold">1. 不可抗力</p>
        <p class="bold">您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务协议下的服务发生中断或终止。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于信息网络设备
          维护、信息网络连接故障、电脑、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、生产力或生产资料不足、火灾、洪水、风暴、爆炸、战争、政府行为、法律法规变动、司法行政机关的命令、其他不可抗力或
          第三方的不作为而造成的不能服务或延迟服务等行为。出现上述情况时，戴尔将努力在第一时间与相关部门配合，及时进行修复，但是由此给您造成的损失，戴尔在法律允许的范围内免责。</p>
        <p class="bold">2. 其他免责事由</p>
        <p class="bold">您理解并同意，在法律允许的范围内，戴尔对以下事由所导致的服务中断或终止不承担责任：</p>
        <p class="bold"> (1) 受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</p>
        <p class="bold"> (2) 用户或戴尔的电脑软件、系统、硬件和通信线路出现故障；</p>
        <p class="bold">(3) 用户操作不当；</p>
        <p class="bold"> (4) 用户通过非戴尔授权的方式使用本服务；</p>
        <p class="bold"> (5) 其他戴尔无法控制或合理预见的情形。</p>
        <p class="bold">3. 信息真实性</p>
        <p class="bold">戴尔提示您，在使用本服务的过程中，您可能会遇到网络信息或其他用户行为带来的风险，该等风险包含他人匿名或冒名的含有威胁、诽谤、令人反感、非法、误导、欺骗等任何信息或行为所造成任何心理、生理上的伤害或经济损失。请您仔细
          甄别，并在遇到上述相关不法行为时及时向戴尔或有关机关举报或投诉。戴尔将对相关内容开展日常检查并在收到举报或投诉时进行相应处理，但请您注意，戴尔不对非戴尔所发出或刊登的任何信息的真实性、适用性、合法性承担责任，也不对因
          第三方侵权行为给您造成的损害负责。</p>
        <p class="bold">4. 责任限制</p>
        <p class="button36 bold">除非另有明确书面说明，在符合法律法规规定的情况下，戴尔不对客户端上的信息、内容、材料、产品或服务做任何形式的明示或默示的声明或担保。</p>

        <p class="bold">十三、法律适用与管辖</p>
        <p>本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。</p>
        <p class="button36">因本协议产生之争议，均应依照中华人民共和国法律予以处理，并诉诸戴尔（中国）有限公司所在地有管辖权的人民法院。</p>

        <p class="bold">十四、适用主体</p>
        <p>戴尔共创Precision 2047号设计大赛网站运营者：戴尔（中国）有限公司</p>


      </div>
      <div class="main-button" @click="toLoginCom">
        <span>返回</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "loginAgreement",
  data(){
    return {
      // 页面级变量
      pageRecord:{
        title:'precision25周年',
        module: 'precision25周年',
        category1: '网站用户服务协议',
      },
    }
  },
  methods:{
    toLoginCom() {
      this.$router.push({path:'/login'});
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/LoginAgreement/pc";
@import "../assets/css/LoginAgreement/wap";
</style>
